import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { IMotionEffectsInitCallbackFactory } from './types'
import { MotionEffectsManager } from './MotionEffectsManager'
import { name } from './symbols'

const motionEffectsInitCallbackFactory: IMotionEffectsInitCallbackFactory = (featureConfig) => (
	motionEffectsManager?: MotionEffectsManager
) => {
	const { animationDefsByCompId, compIdToRotations: rotations } = featureConfig

	if (!motionEffectsManager) {
		return
	}

	return (compId: string, displayedId: string, element: HTMLElement | null) => {
		if (!element) {
			return
		}

		if (displayedId !== compId) {
			let compAnimations = animationDefsByCompId[compId]
			const repeaterTemplateData = JSON.parse(JSON.stringify(compAnimations))

			Object.keys(repeaterTemplateData).forEach((effectId: string) =>
				compAnimations[effectId].forEach((effect) => (effect.targetId = displayedId))
			)
			compAnimations = repeaterTemplateData

			motionEffectsManager.addDefinition(compAnimations, element, rotations[compId])
		}
	}
}

export const MotionEffectsInitCallbackFactory = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	motionEffectsInitCallbackFactory
)
